var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("作業日程詳細")]),
      _c(
        "vab-collapse-info",
        [
          _c("template", { slot: "title" }, [_vm._v("基本情報")]),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 20 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue("blgsnmkj", _vm.info)
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              " （建物CD：" +
                                _vm._s(
                                  _vm.getFieldValue("buildingCd", _vm.info)
                                ) +
                                "） "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品明細")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue("itmdtlnm", _vm.info)
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              " （商品明細CD：" +
                                _vm._s(
                                  _vm.getFieldValue("itemDetailCd", _vm.info)
                                ) +
                                "） "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("点検仕様")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue("workSpecName", _vm.info)
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              " （点検仕様CD：" +
                                _vm._s(
                                  _vm.getFieldValue("workSpecCd", _vm.info)
                                ) +
                                "） "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("協力会社")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.info.bcnfrkj
                                    ? _vm.getFieldValue("bcnfrkj", _vm.info)
                                    : _vm.getFieldValue("supplieName", _vm.info)
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              " （協力会社CD：" +
                                _vm._s(
                                  _vm.info.checkOrganizationCd
                                    ? _vm.getFieldValue(
                                        "checkOrganizationCd",
                                        _vm.info
                                      )
                                    : _vm.getFieldValue("supplierCd", _vm.info)
                                ) +
                                "） "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("作業年月")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_space flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex_space flex_center_align w100_percentage",
                        },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getFieldValue("workYm", _vm.info)) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("発注No連番")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "acceptOrderNoSeq",
                                    _vm.info
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("発注金額")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "flex_end flex_center_align" }, [
                        _c("div", { staticClass: "line_height" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.getFieldValue("costPrice", _vm.info)
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("div", { staticClass: "info_main" }, [
        _c(
          "div",
          {
            staticClass: "head_box flex_start flex_center_align",
            staticStyle: { "padding-top": "12px" },
          },
          [
            _c("svg-icon", {
              staticClass: "font_size_24",
              attrs: { "icon-class": "edit_2_line" },
            }),
            _c("span", { staticClass: "hd_title" }, [_vm._v("作業条件内容")]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "sure_box top_info mtn info_detailed" },
          [
            _c(
              "vab-row",
              { staticClass: "row_box" },
              [
                _c(
                  "vab-col",
                  { staticClass: "title_box", attrs: { span: 4 } },
                  [
                    _c("div", { staticClass: "flex_colum" }, [
                      _c("div", [_vm._v("作業条件")]),
                    ]),
                  ]
                ),
                _c(
                  "vab-col",
                  { staticClass: "word_box nopadding", attrs: { span: 20 } },
                  [
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "table_header br",
                            attrs: { span: 24 },
                          },
                          [_vm._v("日程調整不要")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 br flex_center_align",
                            attrs: { span: 24 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getEnumTextChange(
                                    _vm.getFieldValue(
                                      "weekdayConditionSpecify.adjustUnnecessaryFlg",
                                      _vm.info
                                    ),
                                    _vm.$divisions.unnecessaryFlagEnum
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "table_header br",
                            attrs: { span: 12 },
                          },
                          [_vm._v("FM不在の場合")]
                        ),
                        _c(
                          "vab-col",
                          { staticClass: "table_header", attrs: { span: 12 } },
                          [_vm._v("要日程調整")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 br flex_center_align",
                            attrs: { span: 12 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.isAdjustUnnecessaryFlg
                                    ? _vm.getEnumTextChange(
                                        _vm.getFieldValue(
                                          "weekdayConditionSpecify.fmAbsentCheckableFlg",
                                          _vm.info
                                        ),
                                        _vm.$divisions.checkableFlgEnum
                                      )
                                    : "-"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 flex_center_align",
                            attrs: { span: 12 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getEnumTextChange(
                                    _vm.getFieldValue(
                                      "weekdayConditionSpecify.needAdjustFlg",
                                      _vm.info
                                    ),
                                    _vm.$divisions.necessaryFlagEnum
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          { staticClass: "table_header", attrs: { span: 24 } },
                          [_vm._v("曜日指定")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 flex_center_align",
                            attrs: { span: 24 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getTextValue(
                                    _vm.getFieldValue(
                                      "weekdayConditionSpecify.weekdayLimitContentText",
                                      _vm.info
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "table_header br flex_center_align",
                            attrs: { span: 12 },
                          },
                          [_vm._v(" 日付指定 ")]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass: "table_header flex_center_align",
                            attrs: { span: 12 },
                          },
                          [_vm._v(" 時間指定 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 br flex_colum",
                            attrs: { span: 12 },
                          },
                          [
                            _c("div", { staticClass: "pre_wrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getTextValue(
                                      _vm.getFieldValue(
                                        "weekdayConditionSpecify.dateLimitContentCanText",
                                        _vm.info
                                      )
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getTextValue(
                                      _vm.getFieldValue(
                                        "weekdayConditionSpecify.dateLimitContentCannotText",
                                        _vm.info
                                      )
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 flex_center_align",
                            attrs: { span: 12 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getTextValue(
                                    _vm.getFieldValue(
                                      "weekdayConditionSpecify.timeLimitContentText",
                                      _vm.info
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "table_header br flex_center_align",
                            attrs: { span: 12 },
                          },
                          [_vm._v(" お知らせ文 ")]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass: "table_header flex_center_align",
                            attrs: { span: 12 },
                          },
                          [_vm._v(" 報告書 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 br flex_center_align",
                            attrs: { span: 12 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getTextValue(
                                    _vm.getFieldValue(
                                      "weekdayConditionSpecify.notifyText",
                                      _vm.info
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box8 br flex_center_align",
                            attrs: { span: 12 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getTextValue(
                                    _vm.getFieldValue(
                                      "weekdayConditionSpecify.reportText",
                                      _vm.info
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          { staticClass: "table_header", attrs: { span: 24 } },
                          [_vm._v("自由コメント")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      [
                        _c(
                          "vab-col",
                          {
                            staticClass:
                              "word_box8 flex_center_align no_border word_break",
                            attrs: { span: 24 },
                          },
                          [
                            _c("div", { staticClass: "pre_wrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getTextValue(
                                      _vm.getFieldValue(
                                        "weekdayConditionSpecify.freeComment",
                                        _vm.info
                                      )
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "info_main" },
        [
          _c(
            "div",
            {
              staticClass: "head_box flex_start flex_center_align",
              staticStyle: { "padding-top": "12px" },
            },
            [
              _c("svg-icon", {
                staticClass: "font_size_24",
                attrs: { "icon-class": "edit_2_line" },
              }),
              _c("span", { staticClass: "hd_title" }, [_vm._v("作業日程詳細")]),
            ],
            1
          ),
          _vm._m(0),
          _vm.textSwitch
            ? _c("div", [
                _vm._v(
                  " ※月を跨ぐ作業の追加が必要な場合は、DLNパートナーサポート課にご連絡ください。 "
                ),
              ])
            : _vm._e(),
          _c(
            "vab-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rulesTable } },
            [
              _vm._l(_vm.form.list, function (item, index) {
                return [
                  item.changeFlg != _vm.$divisions.changeFlgEnum.enum_3.value
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "sure_box top_info mtn margin_bottom_12",
                        },
                        [
                          _c(
                            "vab-row",
                            { staticClass: "row_box" },
                            [
                              _c(
                                "vab-col",
                                {
                                  staticClass: "title_box flex_space",
                                  attrs: { span: 24 },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text_8484 font_size" },
                                    [
                                      _vm._v(
                                        " 作業No：" +
                                          _vm._s(
                                            _vm.getFieldValue(
                                              "workingPlanAndResultIdModel.workNo",
                                              item
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "clear_btn margin_top_0 btn_size",
                                      class: {
                                        none_btn:
                                          index === 0 || _vm.deadlineDisabled,
                                      },
                                      staticStyle: { "line-height": "1px" },
                                      attrs: { disabled: index === 0 },
                                      on: {
                                        click: function ($event) {
                                          return _vm.workDel(item, index)
                                        },
                                      },
                                    },
                                    [_vm._v(" 削除 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "vab-row",
                            { staticClass: "row_box" },
                            [
                              _c(
                                "vab-col",
                                {
                                  staticClass:
                                    "word_box border_bottom_none background_f padding_left_6_12 border_right_none",
                                  attrs: { span: 24 },
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "flex_center_align",
                                      attrs: { type: "flex" },
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "flex_center_align",
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "w96 margin_right_8",
                                            },
                                            [_vm._v("予定日時")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "margin_right_16 day_time",
                                            },
                                            [
                                              _c("vab-time", {
                                                attrs: {
                                                  prop:
                                                    "list." +
                                                    index +
                                                    ".workPlanDate",
                                                  ym: _vm.info.workYm,
                                                  "row-item": item,
                                                  "week-show": true,
                                                  "work-change": true,
                                                  disabled:
                                                    _vm.disabledType(
                                                      item,
                                                      "workTime"
                                                    ) || _vm.deadlineDisabled,
                                                },
                                                on: {
                                                  svgClick: function ($event) {
                                                    return _vm.openDay(
                                                      item,
                                                      index
                                                    )
                                                  },
                                                  focusValue: function (
                                                    $event
                                                  ) {
                                                    return _vm.focusValue(index)
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("vab-time-input", {
                                            staticClass: "work_time",
                                            attrs: {
                                              disabled:
                                                _vm.disabledType(
                                                  item,
                                                  "workTime"
                                                ) ||
                                                _vm.$baseLodash.isEmpty(
                                                  item.workPlanDate
                                                ) ||
                                                _vm.deadlineDisabled,
                                              validate: _vm.vaildateTimeStart(
                                                item,
                                                index
                                              ),
                                              "label-error": "予定日時",
                                              "row-item": item,
                                              prop:
                                                "list." +
                                                index +
                                                ".workPlanStartTime",
                                            },
                                            model: {
                                              value: item.workPlanStartTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "workPlanStartTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.workPlanStartTime",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mg8 margin_left_15 margin_right_6",
                                            },
                                            [_vm._v("〜")]
                                          ),
                                          _c("vab-time-input", {
                                            staticClass: "work_time",
                                            attrs: {
                                              "label-error": "予定日時",
                                              validate: _vm.vaildateTimeEnd(
                                                item,
                                                index
                                              ),
                                              disabled:
                                                _vm.disabledType(
                                                  item,
                                                  "workTime"
                                                ) ||
                                                _vm.$baseLodash.isEmpty(
                                                  item.workPlanDate
                                                ) ||
                                                _vm.deadlineDisabled,
                                              "row-item": item,
                                              prop:
                                                "list." +
                                                index +
                                                ".workPlanEndTime",
                                            },
                                            model: {
                                              value: item.workPlanEndTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "workPlanEndTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.workPlanEndTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-col",
                                {
                                  staticClass:
                                    "word_box padding_left_6_12 border_right_none",
                                  class: {
                                    border_bottom_none:
                                      _vm.showReasonFunc(item) && index > 0,
                                  },
                                  attrs: { span: 24 },
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "flex_center_align",
                                      attrs: { type: "flex" },
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "flex_center_align",
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w102 margin_right_8",
                                            },
                                            [_vm._v("作業日コメント")]
                                          ),
                                          _c("vab-textarea", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              maxlength: "1170",
                                              rows: 2,
                                              prop:
                                                "list." +
                                                index +
                                                ".workDateComment",
                                              disabled: _vm.deadlineDisabled,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.showReasonFunc(item) && index > 0
                                ? _c(
                                    "vab-col",
                                    {
                                      staticClass: "word_box padding_left_6_12",
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticClass: "flex_center_align",
                                          attrs: { type: "flex" },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "flex_center_align",
                                              attrs: { span: 24 },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w102 margin_right_8",
                                                },
                                                [_vm._v("追加理由")]
                                              ),
                                              _c("vab-textarea", {
                                                staticClass: "w100_percentage",
                                                attrs: {
                                                  prop:
                                                    "list." +
                                                    index +
                                                    ".addDeleteReason",
                                                  rows: 2,
                                                  maxlength: "520",
                                                  disabled: item.disabled,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              }),
              _c(
                "div",
                { staticClass: "flex_space mg12" },
                [_c("vab-button", { attrs: { "btn-list": _vm.btnAdd } })],
                1
              ),
              _c(
                "vab-collapse",
                { attrs: { title: "削除済みの作業日程を表示" } },
                [
                  _vm._l(_vm.form.list, function (item, index) {
                    return [
                      item.changeFlg ==
                      _vm.$divisions.changeFlgEnum.enum_3.value
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "sure_box top_info mtn info_detailed",
                            },
                            [
                              _c(
                                "vab-row",
                                { staticClass: "row_box" },
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "title_box flex_space",
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text_8484 font_size" },
                                        [
                                          _vm._v(
                                            " 作業No：" +
                                              _vm._s(
                                                _vm.getFieldValue(
                                                  "workingPlanAndResultIdModel.workNo",
                                                  item
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("vab-button", {
                                        attrs: { "btn-list": _vm.makeList },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.workRecover(item, index)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                { staticClass: "row_box" },
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box border_bottom_none disable_box padding_left_6_12 border_right_none",
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticClass: "flex_center_align",
                                          attrs: { type: "flex" },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "flex_center_align",
                                              attrs: { span: 24 },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w96 margin_right_8",
                                                },
                                                [_vm._v("予定日時")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "margin_right_16 day_time",
                                                },
                                                [
                                                  _c("vab-time", {
                                                    attrs: {
                                                      prop:
                                                        "list." +
                                                        index +
                                                        ".workPlanDate",
                                                      ym: _vm.info.workYm,
                                                      "week-show": true,
                                                      "work-change": true,
                                                      disabled: true,
                                                    },
                                                    on: {
                                                      svgClick: function (
                                                        $event
                                                      ) {
                                                        return _vm.openDay(
                                                          item,
                                                          index
                                                        )
                                                      },
                                                      focusValue: function (
                                                        $event
                                                      ) {
                                                        return _vm.focusValue(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("vab-time-input", {
                                                staticClass: "work_time",
                                                attrs: {
                                                  disabled: "",
                                                  prop:
                                                    "list." +
                                                    index +
                                                    ".workPlanStartTime",
                                                },
                                                model: {
                                                  value: item.workPlanStartTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "workPlanStartTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.workPlanStartTime",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mg8 margin_left_15 margin_right_6",
                                                },
                                                [_vm._v("〜")]
                                              ),
                                              _c("vab-time-input", {
                                                staticClass: "work_time",
                                                attrs: {
                                                  disabled: "",
                                                  prop:
                                                    "list." +
                                                    index +
                                                    ".workPlanEndTime",
                                                },
                                                model: {
                                                  value: item.workPlanEndTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "workPlanEndTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.workPlanEndTime",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box disable_box padding_left_6_12 border_right_none",
                                      class: {
                                        border_bottom_none:
                                          item.addDeleteReason &&
                                          item.addDeleteReason !== "",
                                      },
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticClass: "flex_center_align",
                                          attrs: { type: "flex" },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "flex_center_align",
                                              attrs: { span: 24 },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w102 margin_right_8",
                                                },
                                                [_vm._v("作業日コメント")]
                                              ),
                                              _c("vab-textarea", {
                                                staticClass: "w100_percentage",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  rows: 2,
                                                  prop:
                                                    "list." +
                                                    index +
                                                    ".workDateComment",
                                                  maxlength: "1170",
                                                  disabled: "",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  item.addDeleteReason &&
                                  item.addDeleteReason !== ""
                                    ? _c(
                                        "vab-col",
                                        {
                                          staticClass:
                                            "word_box disable_box padding_left_6_12",
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticClass: "flex_center_align",
                                              attrs: { type: "flex" },
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                {
                                                  staticClass:
                                                    "flex_center_align",
                                                  attrs: { span: 24 },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "w102 margin_right_8",
                                                    },
                                                    [_vm._v("削除理由")]
                                                  ),
                                                  _c("vab-textarea", {
                                                    staticClass:
                                                      "w100_percentage",
                                                    attrs: {
                                                      prop:
                                                        "list." +
                                                        index +
                                                        ".addDeleteReason",
                                                      rows: 2,
                                                      disabled: "",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex_space flex_center_align mg12" },
        [
          _c(
            "div",
            { staticClass: "blgsnmkj_class" },
            [
              _c("svg-icon", {
                staticClass: "svg_icon",
                attrs: { "icon-class": "select_work" },
              }),
              _c(
                "el-link",
                { attrs: { type: "primary" }, on: { click: _vm.openCalentar } },
                [_vm._v("カレンダーを表示")]
              ),
            ],
            1
          ),
          _c("vab-button", { attrs: { "btn-list": _vm.btnList } }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "box_dialog",
          attrs: {
            "close-on-press-escape": false,
            "custom-class": "layout-dialog",
            title: "作業No:" + _vm.workNo,
            top: "5vh",
            visible: _vm.visible,
            "append-to-body": "",
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "vab-form",
            {
              ref: "formAdd",
              attrs: { model: _vm.formAdd, rules: _vm.rulesAdd },
            },
            [
              _c("vab-textarea", {
                attrs: {
                  label: "削除理由",
                  "label-width": "1",
                  placeholder: "作業キャンセルのため",
                  prop: "outlineComment",
                  maxlength: "520",
                  rows: "5",
                  "show-word-limit": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer flex_end mg12",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("div", { staticClass: "flex_start flex_center_align" }, [
                _c(
                  "div",
                  { staticClass: "flex_end mg12" },
                  [_c("vab-button", { attrs: { "btn-list": _vm.saveList } })],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("WorkPopupCalender", {
        ref: "WorkPopupCalender",
        staticClass: "work_popup_calender",
      }),
      _c("fixedTime", { ref: "fixedTime", on: { saveData: _vm.saveData } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "h_date" }, [
      _c("span", { staticClass: "h_title" }, [
        _vm._v("作業日程を登録してください"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }